import { InsightCatalogue } from '../InsightCatalogue';
import {
  FullInsightPayload,
  BaseInsightPayload,
  InsightMetric,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface TasksStatusPayload extends FullInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_TASKS_STATUS;
    id: string;
    attributes: {
      data: Array<{
        task_status: string;
        task_count: number;
      }>;
      aggregate: {
        total_tasks: InsightMetric;
      };
    };
  };
}

export const parseTasksStatusPayload = (
  payload: BaseInsightPayload
): TasksStatusPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_TASKS_STATUS,
    data.attributes,
    true,
    true
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<{
      task_status: string;
      task_count: number;
    }>;
    aggregate: {
      total_tasks: InsightMetric;
    };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_TASKS_STATUS,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
        aggregate: {
          total_tasks: typedAttributes.aggregate.total_tasks,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
